export default __webpack_public_path__ + "static/media/car_type.04326101.svg";